<template>
  <cc-container>
    <area-skeleton v-show="showSkeleton"/>
    <cc-header-nav
      class="header"
      v-bind="$attrs"
      v-on="$listeners"
      v-show="!showSkeleton"
    >
      <template slot="right">
        <div  class="ellipsis">
          <van-icon
            class="ellipsis-icon"
            name="ellipsis"
            @click.stop="isShowSmallNav = !isShowSmallNav"
          />
        </div>
      </template>
    </cc-header-nav>
    <cc-main class="main" v-show="!showSkeleton">
      <cc-pull-refresh style="min-height:100%"  v-model="isLoading" @refresh="onRefresh">
        <div class="banner" @click="toPage(ad)">
          <img
            :src="(ad && ad.image) || errorImg" v-error-img="errorImg" alt="">
        </div>
        <div class="warp-list" :style="{background:`#${(ad && ad.background_color) || 'f5f5f5'}`}">
          <van-list
            class="goods-list"
            :class="[!showLoading?'loading-icon':'',(ad&&ad.background_color&&ad.background_color!=='FFFFFF')?'hasAd':'']"
            @click.stop
            v-model="m_loading"
            :finished="m_finished"
            :loading-text ="m_loadText"
            :finished-text="m_finishedText"
            @load="mHandlePullUpLoadMore"
            :immediate-check="m_immediateCheck"
          >
            <slot></slot>
          </van-list>
        </div>

      </cc-pull-refresh>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav"/>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { Icon, List } from 'vant'
import ListMixin from '@/mixins/list'
import AreaSkeleton from './area-skeleton'
Vue.use(Icon).use(List)
export default {
  name: 'area-component',
  components: { AreaSkeleton },
  mixins: [ListMixin],
  props: {
    ad: {
      type: Object,
      default: () => null
    },
    value: {
      type: Boolean,
      default: false
    },
    errorImg: {
      type: String
    },
    showSkeleton: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLoading: this.value,
      isShowSmallNav: false,
      showSearch: false
    }
  },
  methods: {
    onRefresh () {
      this.$emit('onRefresh')
    },
    loadData () {
      this.$emit('loadData')
    },
    toPage (ad) {
      if (ad && ad.url) {
        location.href = ad.url
      }
    }
  },
  watch: {
    value () {
      this.isLoading = this.value
    },
    isLoading () {
      this.$emit('input', this.isLoading)
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    /deep/ {
      background: #ffffff!important;
      color:#333333!important;
      .left-arrow{
        color:#333333!important;
      }
    }
    .search-wrap{
      width: 24px;
      transform: translateX(-5px);
    }
    .search-icon{
      color: #333333;
    }
  }
  .banner{
    height: 130px;
    width: 100%;
    img{
      height: 100%;
      width: 100%;
    }
  }
  .goods{
    padding: 10px;
  }
  .goods-list{
    padding: 10px;
  }
  .ellipsis{
    width: 50%;
    height: 100%;
    @include center();
    &-icon{
      transform: rotate(90deg);
    }
  }
  .warp-list{
    min-height: calc(100vh - 176px);
    /deep/{
      .loading-icon {
        .van-list__loading {
          display: none;
        }
      }
      .hasAd{
        .van-list__finished-text{
          color: #ffffff;
        }
        .van-list__loading {
          color: #ffffff;
        }
      }
    }
  }

</style>
